import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NavigationExtras, Router } from "@angular/router";
import { ToastController } from "@ionic/angular";
import { CookieService } from "ngx-cookie-service";
import { ProductType } from 'src/app/shared-lib/domains/product';
import { CartService } from "../../shared/cart.service";

@Component({
  selector: 'app-mobile-home-folders',
  templateUrl: './mobile-home-folders.component.html',
  styleUrls: ['./mobile-home-folders.component.scss'],
  standalone: false
})
export class MobileHomeFoldersComponent implements OnInit {
  @Input() printProduct;
  @Input() isLoading;
  @Output() closeFoldersEvent = new EventEmitter();
  scrollHeight = 700;

  constructor(public cartService: CartService, private toastController: ToastController, private router: Router, private cookieService: CookieService) {
  }

  @HostListener("window:resize")
  onWindowResize() {
    this.calcScrollHeight();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.calcScrollHeight();
  }

  async reload() {
    if (this.cartService.hasErrors()) {
      const toast = await this.toastController.create({
        message:
          "Algunos archivos tienen errores. Elimínalos antes de continuar.",
        color: "danger",
        position: 'bottom',
        cssClass: "fitWidthToast",
        duration: 2000,
      });
      await toast.present();
      return;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.cookieService.delete('bindingSelected');
    const navigationExtras: NavigationExtras = { state: { item: 'new' } };
    this.router.navigate(["/"], navigationExtras);
    this.closeFolders();
  }

  printGroupItems() {
    return this.cartService.cart.items.filter(
      (item) => item.product.type === ProductType.PRINT && !item.product.vendor
    );
  }

  closeFolders() {
    this.closeFoldersEvent.emit();
  }

  private calcScrollHeight() {
    setTimeout(() => {
      const summaryNoFoldersSection = document.querySelector('#no-folders-section');
      const groupsTitle = document.querySelector('.groups_title');
      this.scrollHeight = window.innerHeight - summaryNoFoldersSection?.clientHeight - groupsTitle?.clientHeight - 100;
    }, 200);

  }
}

